module.exports = __webpack_public_path__ + "static/media/four_monkeys.ef090c23.png";